export const enum CacheableFields {
  FIELD_ASSIGNEE = 'fieldAssignee',
  FIELD_CONTACT_SELECT = 'fieldContactSelect',
  FIELD_CONTACT = 'contact',
}
